import React, { Component } from "react";
import bocconi_logo_neg from "../../assets/images/bocconi-logo-neg.png";
import footer_left_brands from "../../assets/images/footer_brand.svg";
import LoginPageGlobe from "../../assets/images/LoginPage-globe.png";
import { MainStore } from "../../stores/MainStore";
import Button from "../Button";
import Image from "../Image";
import Label from "../Label";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
}

class LoginPage extends Component<
  IProps & React.HTMLAttributes<HTMLImageElement>
> {
  render() {
    return (
      <div className={classes.LoginPage}>
        <div className={classes.LoginHeader}>
          <Image src={bocconi_logo_neg} alt={"Bocconi Logo Header"} fitHeight />
          <Label medium bold id="homepage.title" />
        </div>
        <div className={classes.LoginButtonContainer}>
          <Image src={LoginPageGlobe} alt={"LoginPage Globe"} fitHeight />
          <div className={classes.LabelContainer}>
            <Label uppercase bold medium id={"LoginPage.text.welcome"} />
          </div>
          <div className={classes.LabelContainer}>
            <Label uppercase small id={"LoginPage.text.other"} />
          </div>
          <a
            href={`${window.BASEPATH}saml/login`}
            style={{ textDecoration: "none" }}
          >
            <Button>LOGIN</Button>
          </a>
        </div>
        <div className={classes.FooterBrands}>
          <Image src={footer_left_brands} alt={"Footer brands"} fitHeight />
        </div>
      </div>
    );
  }
}
export default LoginPage;
